import React from 'react';
import { FiCalendar, FiGlobe, FiFileText, FiCheckCircle, FiMap } from 'react-icons/fi';

const TitlePage = ({ site, dateFrom, dateTo, reportData }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Не указана';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Неверная дата';
    return date.toLocaleDateString('ru-RU');
  };

  return (
    <div className="flex flex-col items-center justify-center p-8 sm:p-12 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 dark:from-navy-900 dark:via-navy-800 dark:to-navy-700 relative">
      <div className="flex flex-col h-full w-full">
        {/* Верхняя часть с логотипом */}
        <div className="flex justify-between items-start mb-12">
          <div className="flex items-center gap-4 w-full">
            <img src="/logo.svg" alt="LIUKIT" className="h-12 w-auto" />
            <div>
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
                Веб-студия LIUKIT
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400 w-full">
                Профессиональная разработка и продвижение
              </p>
            </div>
          </div>
          <div className="text-right w-full">
            <p className="text-sm text-gray-600 dark:text-gray-400 w-full">
              Дата генерации
            </p>
            <p className="text-lg font-semibold text-gray-800 dark:text-white">
              {formatDate(dateTo)}
            </p>
          </div>
        </div>

        {/* Центральная часть */}
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          {/* Заголовок отчета */}
          <div className="mb-12 w-full">
            <h1 className="text-5xl sm:text-6xl font-bold text-blue-600 dark:text-blue-400 mb-0">
              Отчет
            </h1>
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-600 dark:text-blue-400 mb-4">
              по комплексному сопровождению сайта
            </h2>
            <div className="flex items-center justify-center gap-3 text-2xl sm:text-3xl font-semibold text-gray-800 dark:text-white">
              <FiGlobe className="w-8 h-8 text-blue-500" />
              <span>{site?.dns || 'ekross.by'}</span>
            </div>
            <div className="flex items-center justify-center gap-3 text-lg text-gray-600 dark:text-gray-400 mt-2 w-full">
              <FiCalendar className="w-5 h-5" />
              <div className="w-[200px]">{formatDate(dateFrom)} - {formatDate(dateTo)}</div>
            </div>
          </div>

          {/* Статистические карточки */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl w-full mb-8">
            <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
              <div className="flex items-center justify-center mb-4">
                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                  <FiMap className="w-6 h-6 text-white" />
                </div>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                {reportData.sitemaps_link}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Страниц в Sitemaps
              </p>
            </div>

            <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
              <div className="flex items-center justify-center mb-4">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <FiFileText className="w-6 h-6 text-white" />
                </div>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                {reportData.pages_count}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Важных страниц отслеживания
              </p>
            </div>

            <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
              <div className="flex items-center justify-center mb-4">
                <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center">
                  <FiCheckCircle className="w-6 h-6 text-white" />
                </div>
              </div>
              <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                {reportData.tasks_count}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Выполненных задач за период
              </p>
            </div>
          </div>

          {/* Новые карточки */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl w-full">
            {reportData.keywords_count > 0 && (
              <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
                <div className="flex items-center justify-center mb-4">
                  <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center">
                    <FiFileText className="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                  {reportData.keywords_count}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Контролируемых поисковых запросов
                </p>
              </div>
            )}
            {reportData.links_in_period > 0 && (
              <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
                <div className="flex items-center justify-center mb-4">
                  <div className="w-12 h-12 bg-pink-500 rounded-full flex items-center justify-center">
                    <FiMap className="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                  {reportData.links_in_period}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Размещённых ссылок за период
                </p>
              </div>
            )}
            {/* ТОП-5 Google */}
            {reportData.top5_google > 0 && (
              <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
                <div className="flex items-center justify-center mb-4">
                  <div className="h-12 w-full rounded-full flex items-center justify-center">
                    <img src="/img/google.svg" alt="Google" className="w-full h-8" />
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                  {reportData.top5_google}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Позиции в ТОП-5 Google (последний съём)
                </p>
              </div>
            )}
            {/* ТОП-10 Google */}
            {reportData.top10_google > 0 && (
              <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
                <div className="flex items-center justify-center mb-4">
                  <div className="h-12 w-full rounded-full flex items-center justify-center">
                    <img src="/img/google.svg" alt="Google" className="w-full h-8" />
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                  {reportData.top10_google}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Позиции в ТОП-10 Google (последний съём)
                </p>
              </div>
            )}
            {/* ТОП-5 Яндекс */}
            {reportData.top5_yandex > 0 && (
              <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
                <div className="flex items-center justify-center mb-4">
                  <div className="h-12 w-full rounded-full flex items-center justify-center">
                    <img src="/img/yandex.svg" alt="Yandex" className="w-full h-8" />
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                  {reportData.top5_yandex}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Позиции в ТОП-5 Яндекс (последний съём)
                </p>
              </div>
            )}
            {/* ТОП-10 Яндекс */}
            {reportData.top10_yandex > 0 && (
              <div className="bg-white/90 dark:bg-navy-700/90 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-600">
                <div className="flex items-center justify-center mb-4">
                  <div className="h-12 w-full rounded-full flex items-center justify-center">
                    <img src="/img/yandex.svg" alt="Yandex" className="w-full h-8" />
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                  {reportData.top10_yandex}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Позиции в ТОП-10 Яндекс (последний съём)
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TitlePage; 